import React, { useMemo, useState } from 'react';
import type { EntityName } from '../auth/Security';
import { SECURITY_ACTIONS, SecuredIconButton, SecuredMenu, SecuredMenuItem } from '../auth/Security';
import I18n from '../i18n/I18n';
import { Icons } from '../icons/Icons';

export default ({
    entityName,
    onSave,
    onSaveAsNew,
    savingFilter
}: {
    entityName: EntityName;
    onSave: () => void;
    onSaveAsNew: () => void;
    savingFilter: boolean;
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const saveSecurityTarget = useMemo(() => ({ entityName }), [entityName]);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleSave = (isNew?: boolean) => {
        setAnchorEl(null);
        isNew ? onSaveAsNew?.() : onSave?.();
    };

    return (
        <>
            <SecuredIconButton
                securityAction={SECURITY_ACTIONS.EDIT}
                onClick={handleOpen}
                loading={savingFilter}
                color="primary"
                size="small"
            >
                <Icons.Save />
            </SecuredIconButton>
            <SecuredMenu
                securityAction={SECURITY_ACTIONS.EDIT}
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <SecuredMenuItem
                    securityAction={SECURITY_ACTIONS.EDIT}
                    securityTarget={saveSecurityTarget}
                    onClick={() => handleSave(false)}
                >
                    <I18n token="common.save" />
                </SecuredMenuItem>
                <SecuredMenuItem securityAction={SECURITY_ACTIONS.EDIT} onClick={() => handleSave(true)}>
                    <I18n token="common.save.as" />
                </SecuredMenuItem>
            </SecuredMenu>
        </>
    );
};
